import { IEnvironment } from 'sc-common/core/models/environment';

export const environment: IEnvironment = {
    production: true,
    project: 'editing-tool',
    portal: 'scientific',
    apiUrl: 'https://api.scientific.net',
    publicBaseUrl: 'https://www.scientific.net',
    mainBaseUrl: 'https://main.scientific.net',
    internalBaseUrl: 'https://admin.scientific.net',
    identityProviderUrl: 'https://idp.scientific.net',
    editingToolBaseUrl: 'https://et.scientific.net',
    contentManagerBaseUrl: 'https://cm.scientific.net'
};
